import React, { useState, useEffect } from 'react';
import config from 'config/common';
import lib from 'lib/commons';

import GiftItem from './GiftItem';
import ModalSelect from './ModalSelect';

const Accumulated = ({
	data: {
		user: {
			id: userId = null,
			name = '',
			accumulation = 0,
			spin_accumulation_reward_history: accumulationHistory = [],
		} = {},
		isClaiming = false,
		eventStarted = 0,
		spinAccumulations = [],
	},
	doClaim,
}) => {
	const [selectData, setSelectData] = useState();
	const [currCanClaim, setCurrCanClaim] = useState(0);
	const [totalCanClaim, setTotalCanClaim] = useState(0);
	// const [maxStage, setMaxStage] = useState(0);
	// const [specialExchangeInfo, setSpecialExchangeInfo] = useState()

	// useEffect(() => {
	//   let max = spinAccumulations[spinAccumulations.length - 1]?.stage || 0;
	//   setMaxStage(max)
	// }, [spinAccumulations])

	// useEffect(() => {
	//   const history = lib.toObj(accumulationHistory, 'spin_accumulation_item_id')
	//   setSpecialExchangeInfo(history)
	// }, [accumulationHistory])

	const handleClaim = (item, canClaim, totalRound) => {
		if (!eventStarted) {
			lib.showMessage(config.demoMsg);
			return false;
		}

		if (!userId) {
			lib.login();
			return false;
		}

		if (item?.rewards.length == 1) {
			return false;
		}

		if (canClaim === 0) {
			lib.showMessage('Bạn không có lượt chọn quà này.');
			return;
		}
		setCurrCanClaim(canClaim);
		setTotalCanClaim(totalRound);
		setSelectData(item);
	};

	const maxStage = spinAccumulations[spinAccumulations.length - 1]?.stage || 0;
	const specialExchangeInfo = accumulationHistory
		? lib.toObj(accumulationHistory, 'spin_accumulation_item_id')
		: '';

	return (
		<>
			<div className="section section--2">
				<div className="wrap-video wrap-video--accumulated no-video">
					<video autoPlay muted loop>
						<source
							src="/images/video2.webm"
							type='video/webm;codecs="vp8, vorbis"'
						/>
					</video>
					<img src="/images/section2.jpg" alt="" />
				</div>
				<div className="accumulated">
					<div className="accumulated__wrap">
						<div className="accumulated__title">
							<img src="/images/title-accumulated.png" alt="" />
							<p>
								<span>Tổng điểm Lucky Star: {accumulation || 0} điểm</span>{' '}
								<br />
								Chỉ cần tích lũy đủ điểm Lucky Star bạn sẽ nhận được những phần
								quà tương ứng
							</p>
						</div>
						{spinAccumulations.length > 0 && (
							<div className="accumulated__gifts">
								<div className="accumulated__gifts--row">
									{lib.getArray(0, 5).map((i, index) => {
										return (
											<GiftItem
												key={index}
												data={spinAccumulations[i]}
												handleClaim={handleClaim}
												accumulation={accumulation}
												specialExchangeInfo={specialExchangeInfo}
												maxStage={maxStage}
											/>
										);
									})}
								</div>
								<div className="accumulated__gifts--row">
									{lib.getArray(6, 8).map((i, index) => {
										return (
											<GiftItem
												key={index}
												data={spinAccumulations[i]}
												handleClaim={handleClaim}
												accumulation={accumulation}
												specialExchangeInfo={specialExchangeInfo}
												maxStage={maxStage}
											/>
										);
									})}
								</div>
								<div className="accumulated__gifts--row">
									{lib.getArray(9, 11).map((i, index) => {
										return (
											<GiftItem
												key={index}
												data={spinAccumulations[i]}
												handleClaim={handleClaim}
												accumulation={accumulation}
												specialExchangeInfo={specialExchangeInfo}
												maxStage={maxStage}
											/>
										);
									})}
								</div>
								<div className="accumulated__gifts--row">
									{lib.getArray(12, 13).map((i, index) => {
										return (
											<GiftItem
												key={index}
												data={spinAccumulations[i]}
												handleClaim={handleClaim}
												accumulation={accumulation}
												specialExchangeInfo={specialExchangeInfo}
												maxStage={maxStage}
											/>
										);
									})}
								</div>
								<div className="accumulated__gifts--row">
									{lib
										.getArray(14, spinAccumulations?.length - 1)
										.map((i, index) => {
											return (
												<GiftItem
													key={index}
													data={spinAccumulations[i]}
													handleClaim={handleClaim}
													accumulation={accumulation}
													specialExchangeInfo={specialExchangeInfo}
													maxStage={maxStage}
												/>
											);
										})}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
			{!!selectData && (
				<ModalSelect
					modalStatus={!!selectData}
					closeModal={() => setSelectData()}
					selectData={selectData}
					doClaim={doClaim}
					isClaiming={isClaiming}
					specialExchangeInfo={specialExchangeInfo}
					totalCanClaim={totalCanClaim}
					currCanClaim={currCanClaim}
					accumulation={accumulation}
				/>
			)}
		</>
	);
};

export default Accumulated;
